import ApiHandler from './ApiHandler';

export default {
    getAnnouncements: data => ApiHandler.post('/announcement/get', data),
    updateAnnouncement: data =>
        ApiHandler.put(`/announcement/${data.id}`, data),
    getOneAnnouncement: data => ApiHandler.get(`/announcement/${data}`)
};
